import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function EFFilterIcon() {
  const isDark = useAppSelector(isDarkTheme)
  const fill = isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'
  return (
    <svg
      width='35'
      height='35'
      viewBox='0 0 35 35'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.9298 23.1225C20.512 23.1225 20.984 23.5945 20.984 24.1767C20.984 24.7589 20.512 25.2309 19.9298 25.2309H15.7131C15.1309 25.2309 14.659 24.7589 14.659 24.1767C14.659 23.5945 15.1309 23.1225 15.7131 23.1225H19.9298ZM24.1465 16.0947C24.7287 16.0947 25.2007 16.5667 25.2007 17.1489C25.2007 17.7311 24.7287 18.2031 24.1465 18.2031H11.4964C10.9142 18.2031 10.4423 17.7311 10.4423 17.1489C10.4423 16.5667 10.9142 16.0947 11.4964 16.0947H24.1465ZM28.3632 9.06689C28.9454 9.06689 29.4174 9.53886 29.4174 10.1211C29.4174 10.7033 28.9454 11.1752 28.3632 11.1752H7.27976C6.69756 11.1752 6.22559 10.7033 6.22559 10.1211C6.22559 9.53886 6.69756 9.06689 7.27976 9.06689H28.3632Z'
        fill={fill}
      />
    </svg>
  )
}
